import API from "./base.service";

export const getUsersAPI = async () => {
  try {
    return await API.get("/user");
  } catch (error) {
    console.error("Failed to fetch users", error);
    return error;
  }
};

export const registerUserAPI = async (user) => {
  try {
    const response = await API.post(`/users`, user);
    return response;
  } catch (error) {
    console.error("Failed to register user", error);
    throw error;
  }
};
export const createSubAdminAPI = async (user) => {
  try {
    const response = await API.post(`/users/create-subadmin`, user);
    return response;
  } catch (error) {
    console.error("Failed to register user", error);
    throw error;
  }
};
export const verifyUserAPI = async (data) => {
  try {
    return await API.post(`/users/verify-otp`, data);
  } catch (error) {
    console.error("Failed to verify user", error);
    throw error;
  }
};

export const userLoginAPI = async (user) => {
  try {
    let url = `/users/login`;
    if (user?.portal === "fleet") url = `/users/login/fleet`;
    if (user?.portal === "supplier") url = `/users/login/supplier`;
    const res = await API.post(url, { email: user.email, password: user.password });
    return res;
  } catch (error) {
    console.log("Failed to login user", error);
    throw error;
  }
};

export const handleLogoutApi = async () => {
  try {
    return await API.post(`/user/logout`);
  } catch (error) {
    console.error("Failed to logout", error);
    throw error;
  }
};

export const getUserDetailApi = async () => {
  try {
    return await API.get(`/users`);
  } catch (error) {
    console.error("Failed to get user details", error);
    throw error;
  }
};

export const resendVerifyCodeUserAPI = async (data) => {
  try {
    return await API.post(`/users/send-verification-code`, data);
  } catch (error) {
    console.error("Failed to resend verification code", error);
    throw error;
  }
};

export const forgotPasswordUserAPI = async (data) => {
  try {
    return await API.post(`/users/send-verification-code`, data);
  } catch (error) {
    console.error("Failed to send forgot password request", error);
    throw error;
  }
};

export const setNewPasswordUserAPI = async (data) => {
  try {
    return await API.post(`/users/update-password`, data);
  } catch (error) {
    console.error("Failed to set new password", error);
    throw error;
  }
};

export const updateUserProfileAPI = async (data) => {
  try {
    return await API.patch(`/users/updateProfile`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    console.error("Failed to update user profile", error);
    throw error;
  }
};
export const updateUser = async (data) => {
  try {
    return await API.put(`/users/${data.id}`, data);
  } catch (error) {
    console.error("Failed to update user profile", error);
    throw error;
  }
};

export const getUserListApi = async (payload) => {
  try {
    const { page, limit, role, start_date, end_date } = payload;
    const query = new URLSearchParams();
    query.append("page", page.toString());
    query.append("limit", limit.toString());

    if (role !== undefined) {
      query.append("role", role.toString());
    }
    if (start_date) {
      query.append("start_date", start_date);
    }
    if (end_date) {
      query.append("end_date", end_date);
    }
    return await API.get(`/users?${query.toString()}`);
  } catch (error) {
    console.error("Failed to fetch user list", error);
    return error;
  }
};

export const updateUserStatus = async (userId, isActive) => {
  try {
    const res = await API.put(`/users/manage-sub-admin-by-admin/${userId}`, {
      is_active: isActive,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const findAllConnectedUsers = async (params = {}) => {
  try {
    return await API.get("/users/findAllConnected", { params });
  } catch (error) {
    throw error;
  }
};

export const uploadProfileImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await API.post(`/users/uploadProfileImage`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const getNotification = async () => {
  try {
    const res = await API.get(`/get_notification`);
    return res;
  } catch (error) {
    throw error;
  }
};
